import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ClearIcon from 'src/icons/untitled-ui/free/x-clear';
import { Dialog, DialogContent, IconButton, Typography, Stack, SvgIcon } from '@mui/material';
import { FileDropzone } from '../file-dropzone';

export const FileUploader = (props) => {
  const { onClose, open = false, onFileSelected, onUploadClicked } = props;
  const [files, setFiles] = useState([]);

  useEffect(() => {
    setFiles([]);
  }, [open]);

  const handleDrop = useCallback((newFiles) => {
    setFiles((prevFiles) => {
      const result = [...prevFiles, ...newFiles];
      onFileSelected(newFiles);
      if (props && !props.onUploadClicked) {
        onClose();
      }
      return result;
    });
  }, []);

  const handleRemove = useCallback((file) => {
    setFiles((prevFiles) => {
      return prevFiles.filter((_file) => _file.path !== file.path);
    });
  }, []);

  const handleRemoveAll = useCallback(() => {
    setFiles([]);
  }, []);

  const handleUpload = () => {
    onUploadClicked(files);
    // Close dialog after handle upload
    onClose();
  };

  return (
    <Dialog closeAfterTransition={false} fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        spacing={3}
        sx={{
          px: 3,
          py: 2,
        }}
      >
        <Typography variant="h6">Chọn một hình để tài lên</Typography>
        <IconButton color="inherit" onClick={onClose}>
          <SvgIcon>
            <ClearIcon />
          </SvgIcon>
        </IconButton>
      </Stack>
      <DialogContent>
        <FileDropzone
          accept={{ 'image/*': [] }}
          // caption="Max file size is 3 MB"
          files={files}
          onDrop={handleDrop}
          onRemove={handleRemove}
          onRemoveAll={handleRemoveAll}
          onUpload={handleUpload}
        />
      </DialogContent>
    </Dialog>
  );
};

FileUploader.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
};
